export const LOGIN_USER = 'login_user'
export const LOGIN_USER_SUCCESS = 'login_user_success'
export const LOGIN_USER_FAIL = 'login_user_fail'
export const LOGIN_USER_CHECK = 'login_user_check'
export const LOGOUT_USER_SUCCESS = 'logout_user_success'
export const LOGIN_SOCIAL_CHECK = 'login_social_check'

export const USERS_FETCH = "users_fetch"
export const USER_FETCH_BY_ID = "user_fetch_by_id"
export const USER_ADD_POINT = "user_add_point"
export const USER_SOCIAL_CHECK = "user_social_check"
export const USER_POINT_FETCH = "user_point_fetch"

export const PRIVILEGE_CREATE = "privilege_create"
export const PRIVILEGE_FETCH = "privilege_fetch"
export const PRIVILEGE_FETCH_DESC = "privilege_fetch_desc"
export const PRIVILEGE_UPDATE = "privilege_update"

export const PROMOTION_CREATE = "promotion_create"
export const PROMOTION_FETCH = "promotion_fetch"
export const PROMOTION_FETCH_BY_ID = "promotion_fetch_by_id"
export const PROMOTION_UPDATE = "promotion_update"

export const BRAND_CREATE = "brand_create"
export const BRAND_FETCH = "brand_fetch"
export const BRAND_FETCH_PROMO = "brand_fetch_promo"
export const BRAND_UPDATE_PROMO = "brand_update_promo"
export const BRAND_UPDATE = "brand_update"

export const PRODUCT_CREATE = "product_create"
export const PRODUCT_FETCH = "product_fetch"
export const PRODUCT_UPDATE = "product_update"
export const PRODUCT_PRICE_UPDATE = "product_price_update"

export const CATALOG_CREATE = "catalog_create"
export const CATALOG_FETCH = "catalog_fetch"

export const DOCUMENT_CREATE = "document_create"
export const DOCUMENT_FETCH = "document_fetch"
export const DOCUMENT_UPDATE = "document_update"

export const SPARE_CREATE = "spare_create"
export const SPARE_FETCH = "spare_fetch"
export const SPARE_UPDATE = "spare_update"